import PhotoSwipeLightbox from "./photoswipe-lightbox.min.js";
if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          buttons: this.querySelectorAll('.media-slider-button'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');

        this.volumeModelBtn = this.querySelector(".product__media-icon-3d");
        if (this.volumeModelBtn && this.mql.matches) {
          this.volumeModelBtn.addEventListener("click", this.openVolumeModel.bind(this));
        }
        this.has3DModel = this.hasAttribute("volume-model-id");

        if (this.hasAttribute("custom-zoom")) {
          this.zoomEnabled = true;
          if (this.has3DModel) {
            const threeDModelId = this.getAttribute("volume-model-id");
            this.threeDModel = document.querySelector(`product-model[data-media-id="${threeDModelId}"]`).cloneNode(true);
          }
          this.initLightbox();
        }

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.buttons?.forEach(button => button.addEventListener('click', this.slideToMedia.bind(this, button)));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
      }

      openVolumeModel() {
        const volumeModelIndex = this.getAttribute("volume-model-index");
        if (volumeModelIndex) {
          this.setActiveMediaViaButton(volumeModelIndex);
          this.volumeModelBtn.classList.add("visibility-hidden");
        }
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      slideToMedia(button) {
        const activeMedia = this.elements.viewer.querySelector('.is-active');
        const mediaIndex = parseInt(activeMedia.getAttribute('data-media-index'));
        const maxIndex = parseInt(activeMedia.getAttribute('data-media-max-index'));
        if (button.hasAttribute('data-target-next')) {
          const mediaToSwitch = mediaIndex === maxIndex ? 0 : mediaIndex + 1;
          this.setActiveMediaViaButton(mediaToSwitch);
        }
        if (button.hasAttribute('data-target-prev')) {
          const mediaToSwitch = mediaIndex === 0 ? maxIndex - 1 : mediaIndex - 1;
          this.setActiveMediaViaButton(mediaToSwitch);
        }
      }

      setActiveMediaViaButton(mediaId) {
        const activeMedia =
        this.elements.viewer.querySelector(`[data-media-index="${mediaId}"]`) ||
        this.elements.viewer.querySelector('[data-media-index]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-index]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList.add('is-active');
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${activeMedia.dataset.mediaId}"]`
        );
        if (this.volumeModelBtn) {
          if (parseInt(this.getAttribute("volume-model-index")) !== mediaId) {
            this.volumeModelBtn.classList.remove("visibility-hidden");
          } else {
            this.volumeModelBtn.classList.add("visibility-hidden");
          }
        }
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);

        if (this.volumeModelBtn) {
          const activMediaPosition = parseInt(activeThumbnail.getAttribute("data-media-index"));
          if (parseInt(this.getAttribute("volume-model-index")) !== activMediaPosition) {
            this.volumeModelBtn.classList.remove("visibility-hidden");
          } else {
            this.volumeModelBtn.classList.add("visibility-hidden");
          }
        }

        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      initLightbox() {
        const config = JSON.parse(this.getAttribute("data-lightbox-config"));
        this.lightboxOptions = {
          gallery: ".product__media-list",
          children: "a",
          pswpModule: () => import("./photoswipe.min.js"),
          ...config
        };
        this.lightbox = new PhotoSwipeLightbox(this.lightboxOptions);
        // override slide content
        if (this.has3DModel) {
          this.lightbox.on("contentLoad", (e) => {
            const { content } = e;
            if (content.type === "3dmodel") {
              // prevent the deafult behavior
              e.preventDefault();
              content.element = document.createElement("div");
              content.element.className = "pswp__3dmodel-container";
              const threeDModel = this.threeDModel ? this.threeDModel.cloneNode(true) : document.createElement("product-model");
              content.element.appendChild(threeDModel);
              threeDModel.loadContent();
            }
          });
        }
        this.lightbox.init();
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 200);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }
    }
  );
}
